import { Badge, Indicator } from '@mantine/core';
import { useCustomerPreRegistrationStats } from '../hooks/useCustomerPreRegistrations';

interface PreRegistrationStatsBadgeProps {
  variant?: 'dot' | 'count';
}

export const PreRegistrationStatsBadge = ({ variant = 'count' }: PreRegistrationStatsBadgeProps) => {
  const { data: stats } = useCustomerPreRegistrationStats();

  if (!stats || stats.pending_count === 0) {
    return null;
  }

  if (variant === 'dot') {
    return (
      <Indicator color="red" size={8} processing>
        <span />
      </Indicator>
    );
  }

  return (
    <Badge color="red" size="sm" variant="filled">
      {stats.pending_count}
    </Badge>
  );
};
